import { render, staticRenderFns } from "./EtapaItensAnuencia.vue?vue&type=template&id=19d253e3&scoped=true"
import script from "./EtapaItensAnuencia.vue?vue&type=script&lang=js"
export * from "./EtapaItensAnuencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d253e3",
  null
  
)

export default component.exports